// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { RecordingAvailability } from "@outschool/gql-backend-generated";
import { joinCommasAnd } from "@outschool/text";
import React from "react";

type MeetingAttendanceData = {
  recordingAvailability?: RecordingAvailability | null;
  attendances?: ReadonlyArray<{
    learner: {
      name?: string | null;
    };
  }> | null;
};

type MeetingAttendanceSection = {
  leader?: {
    name?: string | null;
  } | null;
};

export function formatMeetingAttendance(
  meeting: MeetingAttendanceData,
  section: MeetingAttendanceSection,
): string {
  const learnerNames = (meeting.attendances ?? [])
    .flatMap(({ learner }) => (learner.name ? [learner.name] : []))
    .sort((left, right) => left.localeCompare(right));
  const isRecordingUnavailable =
    meeting.recordingAvailability === RecordingAvailability.Unavailable;
  const attendeeNames = isRecordingUnavailable
    ? learnerNames
    : [section.leader?.name, ...learnerNames].filter((name): name is string =>
        Boolean(name),
      );

  if (attendeeNames.length === 0) {
    return "No one joined.";
  }

  return `${joinCommasAnd(attendeeNames)} joined${
    isRecordingUnavailable ? ", but the teacher did not" : ""
  }.`;
}

export function MeetingAttendance({
  meeting,
  section,
}: {
  meeting: MeetingAttendanceData;
  section: MeetingAttendanceSection;
}) {
  return (
    <React.Fragment>{formatMeetingAttendance(meeting, section)}</React.Fragment>
  );
}
